export const schoolsKey = "schools";
export const schoolClassesKey = "schoolClasses";
export const joinClassKey = "joinClass";
